import { FieldDatatype } from '../../../datatype/Datatype';

export enum AsyncServiceMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
}

export interface IAsyncService {
  id: string;
  name: string;
  url: string;
  method: AsyncServiceMethod;
  inputs: IAsyncServiceParameter[];
  outputs: IAsyncServiceParameter[];
  outputRoot: string | null | undefined;
  type: { id?: string | null; name?: string | null };
}

export interface IAsyncServiceParameter {
  name: string;
  sourcePath?: string | null;
  type: FieldDatatype;
}
